import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Type } from "@angular/compiler";

@Component({
    selector: 'app-items',
    templateUrl: './items.component.html'
})
export class ItemsComponent {
    @Input() color: string;
    @Input() items: { name: string; component: Type[] }[];
    @Output() action: EventEmitter<any> = new EventEmitter<any>();

   constructor(){
    setTimeout(( )=> {
        //console.log(this.items)
    }, 2000)
   }

}